import { integrations } from "@/mocks/home";

export default function LogoStrip() {
  return (
    <section className="relative bg-background-100 py-12 px-4 md:px-8 border-y border-background-300/20">
      <div className="max-w-7xl mx-auto">
        <p className="text-center text-xs font-medium uppercase tracking-[0.2em] text-foreground-600 mb-7">
          Plugged into the tools you already use
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 md:gap-x-14">
          {integrations.map((item) => (
            <div
              key={item.name}
              className="flex items-center gap-2.5 text-foreground-700 hover:text-foreground-950 transition-colors"
            >
              <div className="w-7 h-7 flex items-center justify-center">
                <i className={`${item.icon} text-xl`} aria-hidden></i>
              </div>
              <span className="text-sm font-medium whitespace-nowrap">{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}